import AiSpendBreakdown from '../../../components/AiSpend/AiSpendBreakdown';

export default function AiSpendByOrganization() {
  return (
    <AiSpendBreakdown
      dimension="organization"
      title="Organization"
      description="Spend attributed to the organization that owns the interview. Portfolio work has no organization and is grouped under a dash."
    />
  );
}
